import React, { useState } from 'react';
import { Typography, Grid, Collapse } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import _ from 'lodash';

export default function StandindRow({ row, index }) {
  const [open, setOpen] = useState(false);

  return (
    <tr>
      <td style={{ background: (index + 1) % 2 === 0 ? '#eeeeee' : '#ffff' }}>
        <table style={{ background: '#ffff' }}>
          <tbody>
            <tr>
              <td width='10%'>{row.rank}</td>
              <td width='40%' style={{ textTransform: 'uppercase' }}>
                <Grid item>
                  {open ? (
                    <RemoveIcon
                      style={{ cursor: 'pointer' }}
                      onClick={() => setOpen(!open)}
                    />
                  ) : (
                    <AddIcon
                      style={{ cursor: 'pointer' }}
                      onClick={() => setOpen(!open)}
                    />
                  )}
                  <Typography
                    onClick={() => setOpen(!open)}
                    variant='p'
                    style={{ cursor: 'pointer', color: '#b01e3f' }}
                  >
                    {row.exhibitorName}
                  </Typography>
                </Grid>
              </td>
              <td width='10%'>{row.standingPoints.length}</td>
              <td width='30%' style={{ textTransform: 'uppercase' }}>
                {row.city && row.state ? `${row.city}, ${row.state}` : `N/A`}
              </td>
              <td width='10%'>{row.totalPoints}</td>
            </tr>
          </tbody>
        </table>
        <Collapse in={open} timeout='auto' unmountOnExit>
          <table>
            <tbody>
              <tr
                style={{
                  backgroundColor: '#b01e3f',
                  color: 'white',
                  padding: 4,
                }}
              >
                <th width='50%'>Competition</th>
                <th width='20%'>Dates</th>
                <th width='20%'>Location</th>
                <th width='10%'>Points</th>
              </tr>
              {row.standingPoints.map((com, i) => {
                return (
                  <tr
                    style={{
                      padding: 4,
                      background: (i + 1) % 2 === 0 ? '#ffff' : '#eeeeee',
                    }}
                  >
                    <td
                      style={{
                        border: '1px solid #7a7a7a',
                        textTransform: 'uppercase',
                      }}
                      width='50%'
                    >
                      {com.compName} ({com.compId})
                    </td>
                    <td
                      style={{
                        border: '1px solid #7a7a7a',
                        textTransform: 'uppercase',
                      }}
                      width='20%'
                    >
                      {`${com.startDate} - ${com.endDate}`}
                    </td>
                    <td
                      style={{
                        border: '1px solid #7a7a7a',
                        textTransform: 'uppercase',
                      }}
                      width='20%'
                    >
                      {com.location}
                    </td>
                    <td
                      style={{
                        border: '1px solid #7a7a7a',
                        textTransform: 'uppercase',
                      }}
                      width='10%'
                    >
                      {com.totalPoints}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </Collapse>
      </td>
    </tr>
  );
}
